export default __webpack_public_path__ + "static/media/01.60537e54.png";